import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import Button from 'erpcore/components/Button';
import CustomerCreateEditForm from 'erpcore/screens/Customers/components/CustomerCreateEditForm';
import Modal from 'erpcore/components/Modal';
import { setLocationData } from 'erpcore/components/Form/components/Location/dto';
import { actions as customerActions } from 'erpcore/screens/Customers/Customers.reducer';

const CustomerCreateActionModal = ({ formName }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);

    const handleModal = () => {
        setOpened(!opened);
    };

    const onSubmit = ({ formData }) => {
        const { location } = { ...formData };

        if (location) {
            formData = setLocationData('location', formData);
        }

        return new Promise((resolve, reject) => {
            dispatch({
                type: customerActions.START_CREATE_CUSTOMER,
                promise: { resolve, reject },
                formData
            });
        })
            .then(response => {
                handleModal();
                return dispatch(change(formName, 'company', response?.data?.id));
            })
            .catch(error => {
                return error;
            });
    };

    return (
        <Fragment>
            <Button
                onClick={() => handleModal()}
                variation="action"
                iconName="plus"
                label="Create"
                labelOnlyAria
            />
            <Modal
                variation="medium"
                opened={opened}
                onClose={() => handleModal()}
                title="Add new customer"
            >
                <CustomerCreateEditForm
                    form="CustomerCreateForm"
                    onSubmit={onSubmit}
                    submitLabel="Create"
                    onCancel={() => handleModal()}
                />
            </Modal>
        </Fragment>
    );
};

CustomerCreateActionModal.defaultProps = {
    formName: null
};

CustomerCreateActionModal.propTypes = {
    formName: PropTypes.string
};

export default CustomerCreateActionModal;
